import React, { Component } from 'react';
import { connect } from 'react-redux';
import Autosuggest from 'react-autosuggest';
import IsolatedScroll from 'react-isolated-scroll';
import { Translate } from 'react-redux-i18n';
import { Row, Col } from 'react-bootstrap';
import { fetchProductSuggestions } from '../../actions/autoSuggest_actions';
import { fetchPurchaseOrderProductByID } from '../../actions/purchaseOrders_actions';

/* --------------- */
/*    Component    */
/* --------------- */
class GenericProductSuggest extends Component {
  constructor() {
    super();
    this.state = {
      value: '',
      suggestions: [],
      Product_id: 0,
      noSuggestions: false,
    };
    this.lastRequestId = null;
  }

  componentWillReceiveProps(nextProps) {
    const isInputBlank = nextProps.value === '';
    const noSuggestions = !isInputBlank && nextProps.productSuggestions.length === 0;
    this.setState({ noSuggestions });
    if (nextProps.productSuggestions !== this.props.productSuggestions) {
      this.setState({ isLoading: false, suggestions: [...(nextProps.productSuggestions).slice(0, 200)] });
    }
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
    });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.loadSuggestions(value);
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  onFocus(event) {
    event.target.select();
  }

  onKeyPress = () => {false;}

  onSuggestionSelected = (event, { suggestion }) => {
    let savedEvent = event.target
    // function to get product here
    event.stopPropagation();
    event.preventDefault();
    // console.log('searching by', suggestion);
    if (this.props.setProductNum) {
      this.props.setProductNum(suggestion.ProductNum);
    }
    this.props.fetchOrdersByProduct(suggestion.ProductNum, suggestion, savedEvent);
  }

  getSuggestionValue = (suggestion) => {
    console.log("suggestion: ", suggestion);
    switch (this.props.SearchType) {
      case 'ProductNum':
        return `${suggestion.ProductNum} | ${suggestion.Name}`;
      case 'RefNum':
        return `${suggestion.RefNum} | ${suggestion.Name}`;
      case 'InStock':
        return suggestion.InStock;
      case 'Name':
        return suggestion.Name;
      case 'Description':
        return `${suggestion.Description} | ${suggestion.Name}`;

      default:
        return null;
    }
  }

  loadSuggestions(value) {
    this.props.fetchProductSuggestions(this.props.SearchType, value);
  }

  renderErrorMessage() {
    const { noSuggestions } = this.state;
    if (noSuggestions && !this.props.productSuggestionsIsLoading) {
      return (
        <div className="no-suggestions">
          <Translate value="no_data_found" />
        </div>
      );
    }
    return <div />;
  }

  renderSearchTypeValue(suggestion) {
    switch (this.props.SearchType) {
      case 'ProductNum':
        return suggestion.ProductNum;
      default:
        return suggestion.RefNum;
    }
  }

  renderSuggestion = (suggestion) => 
    <Row className="suggestion" id="suggestion-render" className="sales-auto-suggest-suggestions">
      <Col xs={2}>
        {suggestion.ProductNum}
      </Col>
      <Col xs={2}>
        {suggestion.RefNum}
      </Col>
      <Col xs={2}>
        {suggestion.InStock}
      </Col>
      <Col xs={5}>
        {suggestion.Name}
      </Col>
      <Col xs={1}>
        {suggestion.Description}
      </Col>
    </Row>

  renderSearchTypeHeader = () => {
    switch (this.props.SearchType) {
      case 'ProductNum':
        return <Translate value="prod_num" />;
      default:
        return <Translate value="ref_num" />;
    }
  }

  renderSuggestionsContainer = ({ containerProps, children }) => {
    const { ref, ...restContainerProps } = containerProps;
    const callRef = scrollingDiv => {
      if (scrollingDiv !== null) {
        ref(scrollingDiv.component);
      }
    };

    return (
      <div {...restContainerProps}>
        <div className="container" style={{ width: '100%' }} id="suggestion-container">
          <Row style={{ padding: '10px 5px', margin: '0px' }} className="sales-auto-suggest-suggestions" id="sales-auto-suggest-header">
            <Col xs={2}>
              <Translate value="prod_num" />
            </Col>
            <Col xs={2}>
              <Translate value="ref_num" />
            </Col>
            <Col xs={2}>
              <Translate value="inventory" />
            </Col>
            <Col xs={5}>
              <Translate value="prod_name" />
            </Col>
            <Col xs={1}>
              <Translate value="desc" />
            </Col>
          </Row>
        </div>
        <IsolatedScroll id="suggestions-customer-container" ref={callRef}>
          {children}
        </IsolatedScroll>
      </div>
    );
  }

  render() {
    const { suggestions } = this.state;
    const inputProps = {
      value: this.props.value,
      onChange: this.props.onChange,
      onKeyPress: this.onKeyPress,
      onFocus: this.onFocus,
      id: 'purchase-auto-suggest',
    };

    return (
      <div>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          focusInputOnSuggestionClick={false}
          getSuggestionValue={this.getSuggestionValue}
          renderSuggestion={this.renderSuggestion}
          renderSuggestionsContainer={this.renderSuggestionsContainer}
          onSuggestionSelected={this.onSuggestionSelected}
          highlightFirstSuggestion
          inputProps={inputProps}
        />
        {this.renderErrorMessage()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    productSuggestions: state.autoSuggest.productSuggestions,
    productSuggestionsIsLoading: state.autoSuggest.productSuggestionsIsLoading,
    productSuggestionsError: state.autoSuggest.productSuggestionsError,
  };
}

export default connect(mapStateToProps, { fetchPurchaseOrderProductByID, fetchProductSuggestions })(GenericProductSuggest);



// WEBPACK FOOTER //
// ./master/jsx/containers/Common/GenericProductSuggest.jsx